// extracted by mini-css-extract-plugin
module.exports = {"main__container":"mainLayout_main__container__3hKbL","main__section":"mainLayout_main__section__1lJLW"};